import React, { FunctionComponent } from 'react';
import styles from './Header.module.scss';
import { Link } from 'react-router-dom';
import { path } from 'app/utils/path';
import { BookmarkIcon, HelpoutlineIcon } from 'app/assets/images/icons';
import ProfileMenu from '../../ProfileMenu';
import { useAppSettings } from 'app/context/settings/appSettings';
import Notifications from 'app/components/Notifications';
import { useAuth } from 'app/context/auth';
import DarkModeSwitch from 'app/components/DarkModeSwitch';
import MainSettingsMenu from 'app/components/MainSettingsMenu';
import { _t } from 'app/utils/i18n';
import NotificationReleaseNote from 'notifications/components/NotificationReleaseNote';
const Header: FunctionComponent = ({}) => {
  const { theme } = useAppSettings();
  const { user } = useAuth();

  return (
    <header className={styles.header}>
      <NotificationReleaseNote />
      <div className={styles.container}>
        <nav className={styles.nav}>
          <ul>
            <Link to={path.home}>
              {theme.app.logo ? (
                <div className={styles.Logo} data-testid="test-image">
                  <div className={styles.Logo_img_holder}>
                    <img
                      src={
                        theme.app.logoURl ? theme.app.logoURl : theme.app.logo
                      }
                      alt={theme.app.title + ' logo'}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}
            </Link>
          </ul>

          <ul className={styles.navList}>
            <li className={styles.navItem}>
              <DarkModeSwitch />
            </li>
            <li className={styles.navItem}>
              <Link to="/" className="d-flex">
                <BookmarkIcon />
              </Link>
            </li>
            <li className={styles.navItem}>
              <Notifications />
            </li>
            <li>
              <ProfileMenu />
            </li>
            {/* <li>
              <LanguageDropdown />
            </li> */}
            <li>
              <MainSettingsMenu
                items={[
                  {
                    text: _t('settings:FAQs'),
                    link: path.settings.FREQUENTLY_ASKED_QUESTION,
                  },
                  {
                    text: _t('settings:release_notes'),
                    link: path.users.RELEASE_NOTES,
                  },
                ]}
                icon={<HelpoutlineIcon />}
              />
            </li>
            {user?.site_admin && (
              <li>
                <MainSettingsMenu
                  items={[
                    {
                      text: _t('settings:administrative_settings'),
                      link: path.settings.SETTINGS,
                    },
                    {
                      text: _t('settings:release_notes'),
                      link: path.settings.RELEASE_NOTES,
                    },
                  ]}
                />
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
